import header from './header'
import common from './common'
import error from './error'
import auth from './auth'
import callback from './callback'
import jobs from './jobs'
import workbench from './workbench'
import reportCenter from './reportCenter'
import upgrade from './upgrade'
import talent from './talent'
import profile from './profile'
import login from './login'
import home from './home'
import contentManagement from './contentManagement'
import route from './route'
import emailConfig from './emailConfig'
import versionUpdate from './versionUpdate'
import recruitingAi from './recruitingAi'
import recruitingAiV2 from './recruitingAiV2'
import points from './points'
import profileSettings from './profileSettings'
import resumeImportMonitor from './resumeImportMonitor'
import referral from './referral'
import coldEmail from './coldEmail'
import inbox from './inbox'
import organization from './organization'

const zhCN = {
  header,
  common,
  error,
  auth,
  callback,
  jobs,
  workbench,
  reportCenter,
  upgrade,
  talent,
  profile,
  login,
  home,
  contentManagement,
  route,
  emailConfig,
  versionUpdate,
  recruitingAi,
  recruitingAiV2,
  points,
  profileSettings,
  resumeImportMonitor,
  referral,
  coldEmail,
  inbox,
  organization,
}

export default zhCN
